import React from 'react'
import { Updater, Widget, any, async, fromJSX, nothing } from 'widgets-for-react'
import { ErrorBlock, EventDetailsBlockLayout } from './eventDetailsBlock.layout'
import { EventDetailsState, EventDetailsStateUpdaters } from './eventDetailsBlock.state'
import { EventTemplate } from '../../../models/Events/Events'

export type EventDetailsBlock = {
  state: EventDetailsState
}

export const eventDetailsBlockWidget = (
  block: EventDetailsBlock,
  page?: number
): Widget<Updater<EventDetailsState>> => {
  const { eventId, pageData, eventData } = block.state
  return any([
    async<EventTemplate>(block.state.eventData).map(EventDetailsStateUpdaters.updateEventData),
    fromJSX(() =>
      <EventDetailsBlockLayout
        eventId={eventId}
        pageData={pageData}
        eventData={eventData}
        page={page}
      />),

    // Display error when Event data could not be loaded
    eventData.kind == "failed" ? fromJSX(() => <ErrorBlock />) : nothing()
  ])
}
